import { Button, Dropdown, Icon } from '@wyz/ui';
import { BlobHelpers } from '@wyz/utils';
import * as React from 'react';
import { Trans, useApplicationContext, useConfig } from '~/common/context';
import type { IContainerOrder } from '~/common/types';

const ExportDropdown: React.FC<{
  order: Pick<IContainerOrder, 'id' | 'customer' | 'updatedBySupplier'>;
}> = ({ order }) => {
  const { apiUrl, tenantCode } = useConfig();
  const { auth } = useApplicationContext();

  return (
    <Dropdown.Container>
      <Dropdown.Toggle bsPrefix='toggle' as='div' id='import-export-actions'>
        <Button id='export-btn' variant='outline' size='sm'>
          <Trans i18nKey='app.container.order.detail.export' />
          <Icon icon='arrow-down' size='xxs' className='ms-2' />
        </Button>
      </Dropdown.Toggle>
      <Dropdown.Menu className='dropdown-caret dropdown-menu-card dropdown-menu-end'>
        <Dropdown.Item
          onClick={() => {
            BlobHelpers.download({
              url: `${apiUrl}/offers/api/tenants/${tenantCode}/container-orders/${order.id}/export`,
              token: auth.user?.access_token ?? '',
              inline: false,
            }).catch(() => {});
          }}
          id={'export-initial-container-order'}
        >
          <Icon icon='download' size='xxs' className='me-2' />
          <Trans i18nKey='app.container.order.detail.export.initial_order' />
        </Dropdown.Item>
        <Dropdown.Item
          disabled={!order.updatedBySupplier}
          id={'export-updated-container-order'}
          onClick={() => {
            BlobHelpers.download({
              url: `${apiUrl}/offers/api/tenants/${tenantCode}/container-orders/${order.id}/export`,
              token: auth.user?.access_token ?? '',
              inline: false,
              qs: { updated: 1 },
            }).catch(() => {});
          }}
        >
          <Icon icon='download' size='xxs' className='me-2' />
          <Trans i18nKey='app.container.order.detail.export.updated_order' />
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown.Container>
  );
};

export default ExportDropdown;
